export default {
  namespaced: true,
  state: {
    permissionStatus: null,
  },
  getters: {
    permissionStatus: (state) => state.permissionStatus,
    isGranted: (state) => state.permissionStatus === 'granted',
    isDenied: (state) => state.permissionStatus === 'denied',
  },
  mutations: {
    SET_PERMISSION_STATUS(state, status) {
      state.permissionStatus = status;
    },
  },
  actions: {
    async checkPermission({ commit }) {
      if (!navigator.geolocation) {
        commit('SET_PERMISSION_STATUS', 'denied');
        return;
      }

      try {
        const result = await navigator.permissions.query({
          name: 'geolocation',
        });
        commit('SET_PERMISSION_STATUS', result.state);
        result.onchange = () => commit('SET_PERMISSION_STATUS', result.state);
      } catch {
        commit('SET_PERMISSION_STATUS', 'prompt');
      }
    },
    getCurrentPosition() {
      return new Promise((resolve) => {
        if (!navigator.geolocation) return resolve(null);

        navigator.geolocation.getCurrentPosition(
          (pos) =>
            resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
          () => resolve(null),
          { enableHighAccuracy: true, timeout: 10000 }
        );
      });
    },
  },
};
